module.exports = __webpack_public_path__ + "img/benfica-logo-icon.2226a03f.png";